import { createSlice } from "@reduxjs/toolkit";
import {
  getAdminBidsPageData,
  updatePatientPrescriptionStatus,
  getProviderDetails,
  updateProviderStatus,
  getPrescriptionsByPatientId,
} from "../Thunk/bidsThunk";

const initialState = {
  patients: [],
  providers: [],
  loading: false,
  actionLoading: false,
  detailsLoading: false,
  selectedProviderDetails: null,
  currentPatientDocs: [],
  currentPatientDocsLoading: false,
  error: null,
  pagination: {
    patient: {
      page: 1,
      limit: 20,
      total: 0,
      totalPages: 1,
    },
    provider: {
      page: 1,
      limit: 20,
      total: 0,
      totalPages: 1,
    },
  },
};

const bidsSlice = createSlice({
  name: "bids",
  initialState,
  reducers: {
    clearBidsError: (state) => {
      state.error = null;
    },
    clearProviderDetails: (state) => {
      state.selectedProviderDetails = null;
    },
    clearCurrentPatientDocs: (state) => {
      state.currentPatientDocs = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminBidsPageData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminBidsPageData.fulfilled, (state, action) => {
        state.loading = false;
        state.patients =
          action.payload?.activeTab === "patient"
            ? action.payload?.patients || []
            : state.patients;

        state.providers =
          action.payload?.activeTab === "provider"
            ? action.payload?.providers || []
            : state.providers;

        if (action.payload?.pagination) {
          state.pagination = action.payload.pagination;
        }
      })
      .addCase(getAdminBidsPageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load bids page data";
      })

      .addCase(updatePatientPrescriptionStatus.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(updatePatientPrescriptionStatus.fulfilled, (state, action) => {
        state.actionLoading = false;
        const { patientId, action: statusAction } = action.payload || {};
        const nextStatus = statusAction === "accept" ? "Accepted" : "Rejected";

        state.patients = state.patients.map((item) =>
          String(item.id) === String(patientId)
            ? { ...item, status: nextStatus }
            : item
        );
      })
      .addCase(updatePatientPrescriptionStatus.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload || "Failed to update patient status";
      })

      .addCase(getProviderDetails.pending, (state) => {
        state.detailsLoading = true;
        state.error = null;
      })
      .addCase(getProviderDetails.fulfilled, (state, action) => {
        state.detailsLoading = false;
        state.selectedProviderDetails = action.payload || null;
      })
      .addCase(getProviderDetails.rejected, (state, action) => {
        state.detailsLoading = false;
        state.error = action.payload || "Failed to load provider details";
      })

      .addCase(updateProviderStatus.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(updateProviderStatus.fulfilled, (state, action) => {
        state.actionLoading = false;
        const { providerId, action: statusAction } = action.payload || {};
        const nextStatus = statusAction === "accept" ? "Accepted" : "Rejected";

        state.providers = state.providers.map((item) =>
          String(item.id) === String(providerId)
            ? { ...item, status: nextStatus }
            : item
        );
      })
      .addCase(updateProviderStatus.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload || "Failed to update provider status";
      })

      .addCase(getPrescriptionsByPatientId.pending, (state) => {
        state.currentPatientDocsLoading = true;
      })
      .addCase(getPrescriptionsByPatientId.fulfilled, (state, action) => {
        state.currentPatientDocsLoading = false;
        state.currentPatientDocs = action.payload?.list || [];
      })
      .addCase(getPrescriptionsByPatientId.rejected, (state) => {
        state.currentPatientDocsLoading = false;
        state.currentPatientDocs = [];
      });
  },
});

export const { clearBidsError, clearProviderDetails, clearCurrentPatientDocs } = bidsSlice.actions;
export default bidsSlice.reducer;
